import React from 'react';
import propTypes from 'prop-types';

import { guidelineDeliveryTypeOptions, monthNumberLabel } from '../../../../constants';

const TitleGuideline = ({ guideline, short = false }) => {
  return short ? (
    <p>{`${guideline?.totalSize} | ${guideline?.deliveryType === 'REVIEW' || guideline?.deliveryType === 'REVIEW_AND_DIRECTIONS' ? guideline?.reviewLink : guideline?.primaryKeyword.charAt(0).toUpperCase() + guideline?.primaryKeyword.slice(1)}`}</p>
  ) : (
    <p>{`${guideline?.count} | ${
      monthNumberLabel.find((month) => month.value === parseInt(guideline?.productionDate?.month))
        ?.label
    } | ${
      guidelineDeliveryTypeOptions.find((type) => type.value === guideline?.deliveryType)?.label
    } | ${guideline?.totalSize} | ${guideline?.deliveryType === 'REVIEW' || guideline?.deliveryType === 'REVIEW_AND_DIRECTIONS' ? guideline?.reviewLink : guideline?.primaryKeyword.charAt(0).toUpperCase() + guideline?.primaryKeyword.slice(1)}`}</p>
  );
};

TitleGuideline.propTypes = {
  guideline: propTypes.object,
  short: propTypes.bool,
};

export default TitleGuideline;
